import { get } from 'lodash-es';
import { transformEnabled } from './condition';
import {
  formatBit,
  formatBoolean,
  formatCustom,
  formatEnum,
  formatNumber,
  formatNumberBySeparate,
  formatSignedNumber,
  formatString,
  formatWeek,
  formatBits,
} from './formatFun';
import { getItemDefault } from './utils';

const formatFuns = {
  number: formatNumber,
  signedNumber: formatSignedNumber,
  string: formatString,
  boolean: formatBoolean,
  bit: formatBit,
  bits: formatBits,
  week: formatWeek,
  enum: formatEnum,
  custom: formatCustom,
  numberBySeparate: formatNumberBySeparate,
  default: formatNumber,
};

/**
 *
 * @param data 数据
 * @param rootData 根数据
 * @param config 配置
 * @param result 结果
 * @returns 结果存放
 */
const transformProp = (data: any, rootData: any, config: DpMapItem) => {
  const { type = 'number', name, childMap, loop = false, limit } = config;
  let max = 1;
  let list: any = data[name] ?? getItemDefault(config, data);
  // 处理循环情况
  if (loop) {
    // 是否限制循环次数
    if (limit) {
      // 是否由已解析的数据确认循环次数
      if (typeof limit === 'string' || Array.isArray(limit)) {
        max = get(data, limit, 0);
      } else {
        max = Math.min(limit, list.length);
      }
    } else {
      max = list.length;
    }
  } else {
    list = [list];
  }
  const result: string[] = [];
  for (let i = 0; i < max; i++) {
    const itemValue = list[i] ?? getItemDefault(config, data);
    let value: any;
    // 如果是子类型解析
    if (type === 'child') {
      value = transform(itemValue, rootData, childMap);
    } else {
      // 其他数据类型处理
      if (typeof formatFuns[type] === 'function') {
        // @ts-ignore
        value = formatFuns[type](itemValue, config, rootData);
      } else {
        value = formatFuns.default(itemValue, config, rootData);
      }
    }

    result.push(value);
  }

  return result.join('');
};

const transform = (data: any, rootData: any, dpMap: DpMap) => {
  const result: string[] = [];
  dpMap.forEach(itemConfig => {
    const { condition } = itemConfig;
    if (transformEnabled(condition, rootData, data)) {
      // 执行解析
      result.push(transformProp(data, rootData, itemConfig));
    }
  });
  return result.join('');
};

export const format = (data: any, dpMap: DpMap) => {
  // raw格式数据必须有下发1字节数据，不能传空数据
  if (Array.isArray(data) && dpMap[0]?.type === 'child' && dpMap[0]?.loop) {
    return '00';
  }
  return transform(data, data, dpMap);
};
